import InputFiles from '@/components/Forms/Input/input-files.vue';
import { mapGetters } from 'vuex';
import { showErrorSnackBar, showSuccessSnackBar } from '@/utils/SnackBartHelper';
import Request from './Request/Request.vue';
import ContractsService from '@/services/firebase/Contracts/ContractsService';
import HistoricService from '@/services/firebase/Historic/HistoricService'
import cloneDeep from 'lodash/cloneDeep';
import ProjectsService from '@/services/server/ProjectsService.js';
import ContractStorage from '@/services/storage/ContractStorage';
import ContractRequestStorage from '@/services/storage/ContractRequestStorage';
import UtilsProjects from '@/pages/Projects/Utils/Utils.js';
import diff from 'deep-diff';
import MaterialsService from '@/services/firebase/Materials/MaterialsService';
import NextStepProject from '@/components/Projects/NextStepProject.vue';
import UsersService from '@/services/firebase/Users/UsersService';
import LeadsService from '@/services/firebase/Leads/LeadsService.js';
import ResponsibleTypeService from '@/services/firebase/ResponsibleType/ResponsibleTypeService';
import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import DiagnosticService from '@/services/server/DiagnosticService';
import WaterScanApi from '@/services/apiPdf/WaterScanApi';
import ContractsTemplatesService from '@/services/server/ContractsTemplatesService';
import Utils from "../../../scripts/Utils";
import NotificationsService from "../../../services/server/NotificationsService";
import NewContractModal from "./NewContractModal/NewContractModal.vue";
import ContractList from "./NewContractModal/ContractList.vue";
import ProjectMessagesDialog from '@/components/Projects/ProjectMessages/ProjectMessagesDialog.vue';
import ProjectMessagesService from '@/services/firebase/ProjectsMessages/ProjectMessagesService';
import DiagnosticServiceFirebase from "@/services/firebase/Diagnostic/DiagnosticService";
import { db } from '@/firebase';

export default {
  name: UtilsProjects.STEPS.CONTRACTS,
  components: {
    InputFiles,
    Request,
    NextStepProject,
    NewContractModal,
    ContractList,
    ProjectMessagesDialog
  },
  data: () => ({
    showNewContractModal: false,
    isLoadingPdf: false,
    isLoadingDocx: false,
    dialogDownload: false,
    fileLink: null,
    show_messages_dialog: false,
    projectId: null,
    unreadMessages: 0,
    contractMessages: [],
    isMessagesLoading: false,
    requestContractChanging: false,
    franchiseeData: [
      { header: 'Nome', value: 'Nome do Franqueado' },
      { header: 'Documento', value: 'Documento formatado' },
      {
        header: 'Endereço',
        value: {
          logradouro: 'Logradouro',
          numero: 'Número',
          complemento: 'Complemento',
          bairro: 'Bairro',
          cidade: 'Cidade',
          cep: 'CEP',
          uf: 'UF',
        },
      },
      { header: 'E-mail', value: 'email@franqueado.com' },
      { header: 'Telefone', value: '(00) 12345-6789' },
    ],
    clientData: [
      { header: 'Nome', value: 'Nome do cliente' },
      { header: 'E-mail', value: 'email@cliente.com' },
      { header: 'Documento', value: 'Documento formatado' },
      { header: 'Telefone', value: '(00) 12345-6789' },
      {
        header: 'Endereço',
        value: {
          logradouro: 'Logradouro',
          numero: 'Número',
          complemento: 'Complemento',
          bairro: 'Bairro',
          cidade: 'Cidade',
          cep: 'CEP',
          uf: 'UF',
        },
      },
      {
        header: 'Responsável',
        value: {
          nome: 'Nome do Responsável',
          email: 'email@responsavel.com',
          document: 'Documento Formatado',
          telefone: '(00) 98765-4321',
          qualificação: 'Qualificação do Responsável',
        },
      },
    ],
    proposalsData: [],
    rawProposalsData: [],
    proposalsTableHeader: [
      { text: 'Tipo de Proposta', value: 'proposalType' },
      { text: 'Média de Referência', value: 'referenceAverage' },
      { text: 'Média de Referência - Água', value: 'referenceAverageWater' },
      { text: 'Média de Referência - Esgoto', value: 'referenceAverageSewer' },
      { text: 'Investimento Total', value: 'totalInvestment' },
      { text: '', value: 'actions', sortable: false },
    ],
    proposalsTypeMapper: [
      { text: 'Modelo Performance', value: 'model_performance' },
      { text: 'Venda do Projeto', value: 'investment' },
      { text: 'Pré-Fixado', value: 'pre_fixed' },
      { text: 'Gestão', value: 'management' },
    ],
    itemsMenuPDF: [
      {
        value: 'proposed',
        title: 'Proposta',
        permission_name: 'waterscan_proposal',
      },
      {
        value: 'checklist',
        title: 'Checklist Simples',
        permission_name: 'waterscan_simple_checklist_report',
      },
      {
          value: 'checklist_with_photo',
          title: 'Checklist Foto',
          permission_name: 'waterscan_photo_checklist_report',
      },
    ],
    idProposalPDF: null,
    dialog: false,
    additionalDataDialog: false,
    is_loading: false,
    automaticGenerationContractDialog: false,
    displayCustomAnchorsToFillDialog: false,
    automateContractData: {
      customAnchors: []
    },
    validForm: false,
    activesTemplatesContracts: [],
    selectedTemplate: null,
    selectedProposal: null,
    enableNextStepButton: true,
    buttonMessage: 'Solicitar Materiais',
    confirmExpeditionModal: false,
    project: {},
    initialContract: {},
    contract: {
      contractFile: null,
      observations: null,
      companySideSignedContract: false,
      clientSideSignedContract: false,
      franchiseeSideSignedContract: false,
    },
    mapperToStatusAndRequestsTypes: {
      contract_review: 'Alteração de Contrato',
      signed_contract: 'Contrato Assinado',
      start_contract: 'Contrato Inicial',
      others: 'Outros',
      refused_contract: 'Declinado',

      review_requested: 'Revisão Solicitada',
      under_review: 'Em Revisão',
      reproved: 'Reprovado',
      approved: 'Aprovado',
    },
    requests: [],
  }),
  computed: {
    ...mapGetters(['getCurrentUser', 'getCurrentUserRank']),
    isFranchisee() {
      return this.getCurrentUserRank === 'Franqueado';
    },
    hasNullValuesInCustomAnchors() {
      return this.automateContractData.customAnchors.some(anchor => anchor.value === null || anchor.value === "");
    },
    isTemplateUsed() {
      return (template) => {
        if (!this.contract.requests || !this.contract.requests.length) return false;
        
        // If we're editing a request and it already uses this template, allow it
        if (this.isEditingExistingContract(template)) {
          return false;
        }
        
        // Otherwise check if any request is using this template
        return this.contract.requests.some(request => 
          request.selectedTemplateId === template.id_doc
        );
      };
    },
  },
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
    idLead: {
      type: String,
      default: null,
    },
    idProject: {
      type: String,
      default: null,
    },
    idContract: {
      type: String,
      default: null,
    },
    closeFunc: {
      type: Function,
      default: () => {},
    },
    newLead: {
      type: [Object],
      default: () => ({}),
    },
    currentStep: {
      type: String,
      default: null,
    }
  },
  methods: {
    async checkUnreadMessages() {
      try {
        const { messages } = await ProjectMessagesService.paginationCallsMessagesByProject(null, this.idProject, 'contract');
        const currentUserId = this.getCurrentUser.uid;
        let unreadCount = 0;
        this.contractMessages = messages;
        
        messages.forEach(message => {
          // Verifica se a mensagem foi lida
          const messageRead = message.readers?.some(reader => reader.reader_id === currentUserId) || false;
          if (!messageRead) unreadCount++;
          
          // Verifica comentários não lidos
          if (message.comments) {
            message.comments.forEach(comment => {
              const commentRead = comment.readers?.some(reader => reader.reader_id === currentUserId) || false;
              if (!commentRead) unreadCount++;
            });
          }
        });
        
        this.unreadMessages = unreadCount;
      } catch (error) {
        console.error('Erro ao verificar mensagens não lidas:', error);
      }
    },

    async updateMessagesReaders() {
      try {
        const currentUserId = this.getCurrentUser.uid;
        const updatedMessages = [];
        const messageIds = [];
        
        // Armazenar IDs de mensagens e seus comentários que precisam ser atualizados
        for (const message of this.contractMessages) {
          const messageRead = message.readers?.some(reader => reader.reader_id === currentUserId) || false;
          
          if (!messageRead) {
            messageIds.push(message.id_doc);
          }
          
          updatedMessages.push(message);
        }

        // Se houver mensagens para atualizar, chama o serviço
        if (messageIds.length) {
          await ProjectMessagesService.addReaderToMessages(messageIds, currentUserId);
        }
        
        // Atualizar explicitamente os leitores dos comentários
        for (const message of this.contractMessages) {
          if (message.comments && message.comments.length > 0) {
            await this.updateCommentsReaders(message.id_doc, message.comments, currentUserId);
          }
        }

        this.contractMessages = updatedMessages;
        await this.checkUnreadMessages();
      } catch (error) {
        console.error('Erro ao atualizar leitores das mensagens e comentários:', error);
      }
    },
    
    async updateCommentsReaders(messageId, comments, readerId) {
      try {
        const commentPromises = [];
        const messageRef = db.collection("project_messages").doc(messageId);
        
        for (const comment of comments) {
          // Verificar se o comentário já foi lido por este usuário
          const commentRead = comment.readers?.some(reader => reader.reader_id === readerId) || false;
          
          if (!commentRead && comment.id_doc) {
            const commentRef = messageRef.collection('comments').doc(comment.id_doc);
            const currentReader = {
              reader_id: readerId,
              read_at: new Date()
            };
            
            // Adicionar o leitor ao comentário
            const newReaders = [...(comment.readers || []), currentReader];
            commentPromises.push(commentRef.update({ readers: newReaders }));
          }
        }
        
        if (commentPromises.length > 0) {
          await Promise.all(commentPromises);
        }
      } catch (error) {
        console.error('Erro ao atualizar leitores dos comentários:', error);
      }
    },

    async openMessagesDialog() {
      this.projectId = this.idProject;
      
      // Ativa o loading
      this.isMessagesLoading = true;
      
      try {
        // Primeiro atualiza os leitores das mensagens
        await this.updateMessagesReaders();
        
        // Depois abre o diálogo
        this.show_messages_dialog = true;
        
        // Aguardar o próximo ciclo de renderização para garantir que o componente ProjectMessagesDialog esteja montado
        this.$nextTick(async () => {
          if (this.$refs.projectMessagesDialog) {
            await this.$refs.projectMessagesDialog.openDialog();
          } else {
            console.error("Componente ProjectMessagesDialog não encontrado");
          }
        });
      } catch (error) {
        console.error("Erro ao abrir o diálogo de mensagens:", error);
      } finally {
        // Desativa o loading após um pequeno delay para garantir que a transição seja suave
        setTimeout(() => {
          this.isMessagesLoading = false;
        }, 500);
      }
    },
    isEditingExistingContract(template) {
      return this.$refs.newContractModal &&
             this.$refs.newContractModal.currentContract &&
             this.$refs.newContractModal.currentContract.id_doc &&
             this.$refs.newContractModal.currentContract.selectedTemplateId === template.id_doc;
    },
    async sendNotification(message) {
      let messageList = [];
      let data = UtilsProjects.buildFranchiseeNotificationData(this.project, message);

      messageList.push(data)

      if (this.project.configs?.wpp_notification ?? true) {
        await NotificationsService.bootProjectNotification(messageList)
      }
    },
    async handleContractAdd(contract) {
      this.closeNewContractModal();
      
      // Insert at the beginning of the array and ensure it's a fresh copy
      const contractCopy = cloneDeep(contract);
      this.contract.requests.unshift(contractCopy);

      // Encontrar a proposta correspondente para obter o tipo
      const proposal = this.rawProposalsData.find(p => p.id_doc === contractCopy.selectedProposalId);
      const proposalType = proposal ? this.mapProposalsType(proposal.typeProposal.type) : 'Tipo não especificado';
      const templateSlug = this.getTemplateSlug(contractCopy.selectedTemplateId);
      const message = `Um novo contrato ${templateSlug ? `de: ${templateSlug} ` : '' }para a proposta: ${proposalType}, foi criado`;
      await this.sendNotification(message);
      await this.addStautsProject(this.idProject,507,504)
    },
    async handleContractEdit(contract) {
      this.closeNewContractModal();
      
      const contractCopy = cloneDeep(contract);
      // Update the contract in the list by replacing it
      this.contract.requests = this.contract.requests.map(
          request => request.id_doc === contractCopy.id_doc ? contractCopy : request
      );

      // Encontrar a proposta correspondente para obter o tipo
      const proposal = this.rawProposalsData.find(p => p.id_doc === contractCopy.selectedProposalId);
      const proposalType = proposal ? this.mapProposalsType(proposal.typeProposal.type) : 'Tipo não especificado';
      const templateSlug = this.getTemplateSlug(contractCopy.selectedTemplateId);

      const message = `Um contrato ${templateSlug ? `de: ${templateSlug} ` : '' }para a proposta: ${proposalType}, foi atualizado.`;

      await this.addStautsProject(this.idProject,506,503)

      await this.sendNotification(message);
    },
    handleContractDetails(contract) {
      this.openNewContractModal(true, contract);
    },
    openNewContractModal(isEditing = false, contractToEdit = null) {
      // For new contracts, force a complete reset of all related state
      if (!isEditing) {
        // Reset any selected template/proposal
        this.selectedTemplate = null;
        this.selectedProposal = null;
      }
      
      this.showNewContractModal = true;
      
      this.$nextTick(() => {
        if (this.$refs.newContractModal) {
          if (isEditing && contractToEdit) {
            this.$refs.newContractModal.setContractForEditing(contractToEdit);
          } else {
            // Force a complete reset of the modal state
            this.$refs.newContractModal.resetContractState();
          }
        }
      });
    },
    closeNewContractModal() {
      // First set modal visibility to false
      this.showNewContractModal = false;
      
      // Reset the contract generation variables to prevent state persistence
      if (!this.$refs.newContractModal?.isUpdateMode) {
        this.selectedTemplate = null;
        this.selectedProposal = null;
        this.automaticGenerationContractDialog = false;
        this.displayCustomAnchorsToFillDialog = false;
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
    async addStautsProject(id_project, status, statusAdm = null) {
      await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.CONTRACTS, status, this.currentStep)
      await UtilsProjects.addStatusProject(id_project, UtilsProjects.STEPS.CONTRACTS, statusAdm ? statusAdm : status, this.currentStep, false)
    },
    async pdfRequest(id_doc, action) {
      this.idProposalPDF = id_doc;
      const proposal = this.rawProposalsData.find(proposal => proposal.id_doc === id_doc);
      try {
        await DiagnosticServiceFirebase.legacyDiagnosticSolution(proposal.id_diagnostic)
        const solution = await DiagnosticServiceFirebase.getDiagnosticSolutionByDiagnosticId(proposal.id_diagnostic)
        if (!solution) {
          solution = []
        }
        let response = null;
        switch (action) {
          case 'proposed':
            response = await WaterScanApi.generateDiagnosticProposalPdf(proposal.id_doc)
            if (response.status === 200 && typeof response.data.signedUrl) {

              this.fileLink = response.data.signedUrl
              this.dialogDownload = true
              // await WaterScanApi.downloadPdf(response)
              await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.APPROVAL, "Proposta Baixada", this.currentStep)
            }
            else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")

            break;
          case 'checklist':
            response = await WaterScanApi.generateDiagnosticChecklistPdf(proposal.id_doc)
            if (response.status === 200 && typeof response.data.signedUrl){
              this.fileLink = response.data.signedUrl
              this.dialogDownload = true
              // await WaterScanApi.downloadPdf(response)
              await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.APPROVAL, "Checklist Baixado", this.currentStep)
            }
            else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
            break;
          case 'checklist_with_photo':
            response = await WaterScanApi.generateChecklisWithPhotoSevenStepsPdf(proposal.id_doc, this.project.id_lead)
            if (response.status === 200 && typeof response.data.signedUrl) {
              this.fileLink = response.data.signedUrl
              this.dialogDownload = true

              // await WaterScanApi.downloadPdf(response)
              await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.APPROVAL, "Checklist Com Foto Baixado", this.currentStep)
            }
            else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
            break;
        }
      } catch (error) {
        console.error(error);
      }
      this.idProposalPDF = '';
    },
    mapProposalsType(proposalType) {
      return (this.proposalsTypeMapper.find(type => type.value === proposalType) || {}).text || 'Tipo não encontrado';
    },
    getTemplateSlug(templateId) {
      const template = this.activesTemplatesContracts.find(t => t.id_doc === templateId);
      return template ? template.templateSlug : 'Template não encontrado';
    },
    async resolveReferenceAverages(historic) {
      try {
        if (historic.length === 0) {
          return {
            waterAverage: 0,
            sewerAverage: 0,
            accountAmountAverage: 0,
          };
        }

        const total = historic.reduce(
          (acc, item) => {
            acc.water += item.water || 0;
            acc.sewer += item.sewer || 0;
            acc.accountAmount += parseFloat(item.accountAmount || 0);
            return acc;
          },
          { water: 0, sewer: 0, accountAmount: 0 }
        );

        const waterAverage = total.water / historic.length;
        const sewerAverage = total.sewer / historic.length;
        const accountAmountAverage = total.accountAmount / historic.length;

        return {
          waterAverage: waterAverage.toFixed(2),
          sewerAverage: sewerAverage.toFixed(2),
          accountAmountAverage: accountAmountAverage.toFixed(2),
        };
      } catch (error) {
        console.error('Erro ao processar os históricos:', error);
        return {
          waterAverage: 0,
          sewerAverage: 0,
          accountAmountAverage: 0,
        };
      }
    },
    resolveTotalInvestment(listProducts, listServices, listSolutions, proposal) {
      const calculateTotal = list => {
        return list.reduce((acc, item) => acc + (item.total || 0), 0);
      };

      const totalProducts = calculateTotal(listProducts);
      const totalServices = calculateTotal(listServices);
      const totalSolutions = calculateTotal(listSolutions);

      const grandTotal = totalProducts + totalServices + totalSolutions;

      if (proposal.typeProposal.hasDiscount) {
        let discountValue = proposal.typeProposal.discountValue || 0;

        if (proposal.typeProposal.discountType === 'percentage') {
          const discountAmount = (grandTotal * discountValue) / 100;
          return this.formatCurrency(grandTotal - discountAmount);
        } else if (proposal.typeProposal.discountType === 'monetary') {
          return this.formatCurrency(grandTotal - discountValue);
        }
      }

      return this.formatCurrency(grandTotal);
    },
    addUniqueHistoricsToSet(historicsSet, historics) {
      if (historics && historics.length){
        historics.forEach(historic => {
          if (!Array.from(historicsSet).some(existing => existing.month === historic.month)) {
            historicsSet.add(historic);
          }
        });
      }
    },
    async retrieveHistoric(idDiagnostic) {
      try {
        const diagnostic = await DiagnosticService.findById(idDiagnostic);
        const historicFromDb = await HistoricService.getAllHistoricsByProjectId(this.idProject);
        const ListHistorics = diagnostic?.data?.data?.historics;

        const historicsSet = new Set();

        this.addUniqueHistoricsToSet(historicsSet, historicFromDb)
        this.addUniqueHistoricsToSet(historicsSet, ListHistorics)
        return Array.from(historicsSet);
      } catch (error) {
        console.error('Erro ao recuperar o histórico:', error);
        return [];
      }
    },
    async retrieveProposalsData() {
      try {
        const historic = await this.retrieveHistoric(this.project.id_diagnostic);
        const { waterAverage, sewerAverage, accountAmountAverage } = await this.resolveReferenceAverages(historic);
        for (const proposalId of this.contract.proposals) {
          const proposal = await DiagnosticProposalService.getProposalById(proposalId);
          this.rawProposalsData.push(proposal);
          this.proposalsData.push({
            id_doc: proposal.id_doc,
            proposalType: this.mapProposalsType(proposal.typeProposal.type),
            referenceAverage: this.formatCurrency(accountAmountAverage),
            referenceAverageWater: `${waterAverage} m³`,
            referenceAverageSewer: `${sewerAverage} m³`,
            totalInvestment: this.resolveTotalInvestment(
              proposal.listProducts,
              proposal.listServices,
              proposal.listSolutions,
              proposal
            ),
          });
        }
      } catch (error) {
        console.error('Erro ao recuperar as propostas:', error);
        showErrorSnackBar('Erro ao carregar propostas: ' + error.message);
      }
    },
    resolveDocumentType(value) {
      const isCPFDocument = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(value);
      const isCNPJDocument = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(value);
      return isCPFDocument ? 'CPF' : isCNPJDocument ? 'CNPJ' : 'Documento';
    },
    async resolveResponsibleType(responsibleTypeId) {
      try {
        const responsibleTypes = await ResponsibleTypeService.getResponsibleTypes();

        const matchedType = responsibleTypes.find(type => type.id_doc === responsibleTypeId);

        return matchedType ? matchedType.name : 'N/E';
      } catch (error) {
        console.error('Erro ao buscar o tipo de responsável:', error);
        return 'Erro ao buscar o tipo de responsável';
      }
    },
    fillCustomAnchors() {
      this.displayCustomAnchorsToFillDialog = true
      this.automaticGenerationContractDialog = false

      this.initializeCustomAnchors();
    },
    openContractGenerationModal() {
      if (this.selectedTemplate) {
        this.displayCustomAnchorsToFillDialog = true
      } else {
        this.automaticGenerationContractDialog = true
      }
    },
    chooseAnotherTemplate() {
      this.selectedTemplate = null
      this.selectedProposal = null
      this.displayCustomAnchorsToFillDialog = false
      this.automaticGenerationContractDialog = true
    },
    initializeCustomAnchors() {
      if (this.selectedTemplate) {
        this.automateContractData.customAnchors = this.selectedTemplate.customAnchors.map(anchor => ({
          id_doc_anchor: anchor.id_doc,
          name: anchor.anchorName,
          value: null,
        }));
      }
    },
    async generateContract(isPdf) {
      if (isPdf) {
        this.isLoadingPdf = true;
      } else {
        this.isLoadingDocx = true;
      }
      try {
        const templateId = this.selectedTemplate.id_doc;

        if (templateId) {
          const templateData = await ContractsTemplatesService.getTemplateById(templateId);
          this.selectedTemplate = cloneDeep(templateData.data.data);
        } else {
          showErrorSnackBar('Nenhum ID de template encontrado');
          return;
        }

        // Check if this template is already used in another contract
        // Skip check if we're editing the same contract that already uses this template
        const isEditingExistingTemplate = this.$refs.newContractModal && 
                                         this.$refs.newContractModal.currentContract && 
                                         this.$refs.newContractModal.currentContract.id_doc && 
                                         this.$refs.newContractModal.currentContract.selectedTemplateId === templateId;
        
        if (!isEditingExistingTemplate && this.isTemplateUsed(this.selectedTemplate)) {
          showErrorSnackBar('Este template já está sendo usado em outro contrato. Por favor, selecione um template diferente.');
          this.isLoadingPdf = false;
          this.isLoadingDocx = false;
          return;
        }

        const receivedContract = await this.processContract(isPdf);
        
        const contractFile = this.createFileFromContract(receivedContract, isPdf);
        this.downloadFile(contractFile);
        this.notifyNewContractModal();
        
      } catch (e) {
        console.error(`unexpected error: ${e}`);
        showErrorSnackBar(`Aconteceu um erro inesperado. Contacte o suporte técnico e informe o código: GC-01`)
      } finally {
        this.isLoadingPdf = false;
        this.isLoadingDocx = false;
        this.displayCustomAnchorsToFillDialog = false;
      }
    },
    async processContract(isPdf) {
      this.automateContractData.isPdf = isPdf;
      this.automateContractData.template_path = this.selectedTemplate.filePath;
      this.automateContractData.project_data = this.project;
      this.automateContractData.id_proposal = this.selectedProposal.id_doc;

      return await ContractsTemplatesService.generateContract(this.automateContractData);
    },
    createFileFromContract(receivedContract, isPdf) {
      const bufferData = receivedContract.data.data;
      const arrayBuffer = new Uint8Array(bufferData.data).buffer;
      const fileBlob = new Blob([arrayBuffer], { type: `${isPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'}` });
      const fileExtension = isPdf ? 'pdf' : 'docx';
      const fileName = `${this.selectedTemplate.templateName}.${fileExtension}`;
      return new File([fileBlob], fileName, { type: fileBlob.type });
    },
    downloadFile(file) {
      const contractGenerated = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = contractGenerated;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(contractGenerated);
    },
    notifyNewContractModal() {
      if (this.$refs.newContractModal) {
        this.$refs.newContractModal.handleContractGenerated(
          this.selectedTemplate.id_doc,
          this.selectedProposal.id_doc,
          this.selectedProposal.typeProposal.type,
          null,
          this.contract.requests
        );
      }
    },
    async retrieveFranchiseeInformation() {
      this.is_loading = true;
      try {
        const result = await UsersService.getUsersById(this.project.id_franchisee);
        const { name, metadata, email } = result;

        this.franchiseeData[0].value = name;
        this.franchiseeData[1].header = metadata.idType || 'Documento';
        this.franchiseeData[1].value = metadata.idNumber;
        this.franchiseeData[2].value = {
          logradouro: metadata.address.logradouro,
          numero: metadata.address.numero,
          complemento: metadata.address.complemento,
          bairro: metadata.address.bairro,
          cidade: metadata.address.cidade,
          cep: metadata.address.cep,
          uf: metadata.address.uf,
        };
        this.franchiseeData[3].value = email;
        this.franchiseeData[4].value = metadata.phone;
      } catch (error) {
        showErrorSnackBar(error.message);
      } finally {
        this.is_loading = false;
      }
    },
    async retrieveClientInformation() {
      this.is_loading = true;
      try {
        const result = await LeadsService.getLeadsById(this.idLead);

        this.clientData[0].value = result.name;
        this.clientData[1].value = result.email;
        this.clientData[2] = {
          header: this.resolveDocumentType(result.document),
          value: result.document || 'N.I',
        };
        this.clientData[3].value = result.phone;
        this.clientData[4].value = {
          logradouro: result.address,
          numero: result.house_number,
          complemento: result.address_complement || 'N/A',
          bairro: result.district,
          cidade: result.city,
          cep: result.zip_code,
          uf: result.uf,
        };

        this.clientData[5].value = {
          nome: result.responsible_name,
          email: result.responsible_email,
          [this.resolveDocumentType(result.responsible_document)]: result.responsible_document,
          telefone: result.responsible_phone,
          qualificação: await this.resolveResponsibleType(result.id_responsible_type),
        };
      } catch (error) {
        showErrorSnackBar(error.message);
      } finally {
        this.is_loading = false;
      }
    },
    async downloadDocument(url) {
      this.is_loading = true;
      const img = await ContractStorage.downloadImg(url);
      window.open(URL.createObjectURL(img), '_blank');
      this.is_loading = false;
    },
    emitContract() {
      this.$emit('param:update', this.contract);
    },
    async addRequest(request, index) {
      let messageList = [];
   
      switch (request.requestType) {
        case "start_contract":
          await this.addStautsProject(this.idProject,507,504)
          break;
        case "contract_review":
          await this.addStautsProject(this.idProject,506,503)
          break;
        case "signed_contract":
          await this.addStautsProject(this.idProject,509,501)
          break;
        default:
          break;
      }
      if (index < 0) {
        this.requests.unshift(request);
        await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.CONTRACTS, 'Nova Requisição',
                this.currentStep,);
      } else {
        const initialRequest = this.requests[index];

        const changes = diff(initialRequest, request) || [];
        const diffIsDecision = changes.some(({ path }) => {
          if (!path) return false;
          return path.includes('observationsDecision') || path.includes('status');
        });

        if (diffIsDecision) {
          switch (changes[1].rhs) {
            case 'approved':
              await UtilsProjects.createSuccessLog(
                this.idProject,
                UtilsProjects.STEPS.CONTRACTS,
                'Requisição Aprovada',
                this.currentStep,
              );
              break;
            case 'under_review':
              await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.CONTRACTS, 'Requisição Em Revisão',
                this.currentStep);
              break;
            case 'reproved':
              await UtilsProjects.createWarningLog(
                this.idProject,
                UtilsProjects.STEPS.CONTRACTS,
                'Requisição Reprovada',
                this.currentStep,
              );
              break;
          }
          let data = UtilsProjects.buildFranchiseeNotificationData(this.project,
          `Foi tomada uma decisão na solicitação do tipo: *${this.mapperToStatusAndRequestsTypes[request.requestType]}* e agora possui o status *${this.mapperToStatusAndRequestsTypes[request.status]}*, verifique a aba de *CONTRATOS* no seu projeto para mais detalhes!`);
          messageList.push(data)
          if (this.project.configs?.wpp_notification ?? true) {
            await NotificationsService.bootProjectNotification(messageList)
          }
        } else {
          await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.CONTRACTS, 'Requisição Editada',
            this.currentStep);
        }
        this.$set(this.requests, index, request);
      }
      this.emitContract();
      await this.saveRequest(request, index);
    },
    async removeRequest(index) {
      const requestToDelete = this.requests[index]
      this.requests = this.requests.filter((_, i) => i !== index);
      if (this.idContract) await ContractsService.deleteRequestsByContractIdAndRequest(this.idContract, requestToDelete);
      showSuccessSnackBar('Requisição deletada com sucesso!');
      await UtilsProjects.createInfoLog(this.idProject, UtilsProjects.STEPS.CONTRACTS, 'Requisição Deletada',
        this.currentStep,);
    },
    openRequest() {
      this.$refs.request.openDialog();
    },
    closeRequest() {
      this.$refs.request.closeDialog();
    },
    async checkIfExistsContractImagesToSave(contract) {
      if (contract.hasOwnProperty('contractFile') && contract.contractFile) {
        const allowedTypes = [
          'application/pdf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];

        if (this.initialContract?.contractFilePath) {
          await ContractStorage.deleteImg(this.initialContract.contractFilePath);
        }

        contract.contractFilePath = null;

        if (allowedTypes.includes(contract.contractFile.type)) {
          contract.contractFilePath = await ContractStorage.uploadFile(this.contract.id_doc, contract.contractFile);
        } else {
          contract.contractFilePath = await ContractStorage.uploadImg(this.contract.id_doc, contract.contractFile);
        }

        delete contract.contractFile;
      }
    },
    async checkIfExistsRequestsImagesToSave(idContract, request) {
      if (request.hasOwnProperty('signedContractFile') && request.signedContractFile) {
        const allowedTypes = [
          'application/pdf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];

        request.contractFilePath = null;

        if (allowedTypes.includes(request.signedContractFile.type)) {
          request.signedContractPath = await ContractRequestStorage.uploadFile(idContract, request.signedContractFile);
        } else {
          request.signedContractPath = await ContractRequestStorage.uploadImg(idContract, request.signedContractFile);
        }

        delete request.signedContractFile;
      }
    },
    async saveRequest(request) {
      let messageList = [];


      try {
        this.is_loading = true;
        if (request && request.id_doc)
          await ContractsService.updateRequestContractById(this.idContract, request.id_doc, request);
        else {
          const idContract = await ContractsService.createRequestContractById(this.idContract, request);

          if (this.getCurrentUserRank !== 'Franqueado') {
            let data = UtilsProjects.buildFranchiseeNotificationData(this.project,
            `Foi adicionado um novo contrato para a proposta de no projeto ${this.project.name}`);

            messageList.push(data)
            if (this.project.configs?.wpp_notification ?? true) {
              await NotificationsService.bootProjectNotification(messageList)
            }
          } else {
            /* Inserir notificação para os admins/analistas do sistema de que uma solicitação foi criada. */
          }

          request = request.id_doc = idContract;
        }
      } catch (e) {
        console.error(e);
      } finally {
        showSuccessSnackBar('Requisição salva com sucesso!');
        this.is_loading = false;
      }

    },
    async saveContract() {
      if (this.contract.contractFile === null) {
        showErrorSnackBar('É necessário anexar um contrato!');
        return;
      }
      this.is_loading = true;
      if (this.idContract) {
        await ContractsService.updateContractById(this.idContract, this.contract);
        await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.CONTRACTS, 'Contrato Anexado', this.currentStep);
      }
      this.is_loading = false;

      showSuccessSnackBar('Contrato salvo com sucesso!');
      this.closeContractModal();
    },
    closeContractModal() {
      this.closeFunc(UtilsProjects.STEPS.CONTRACTS);
    },
    async getActivesContractsTemplates() {
      const response = await ContractsTemplatesService.getActives();
      this.activesTemplatesContracts = response.data.data;
    },
    async getContractFromDB() {
      const contract = await ContractsService.getContractById(this.idContract);

      const templateId = contract.selectedTemplate?.id_doc ?? contract.selectedTemplateId;

      if (templateId) {
        try {
          const templateData = await ContractsTemplatesService.getTemplateById(templateId);
          this.selectedTemplate = templateData.data.data;
        } catch (error) {
          showErrorSnackBar('Template não encontrado com o ID informado');
          console.error('Erro ao buscar template:', error);
        }
      }

      this.initialContract = cloneDeep(contract);
      this.contract = cloneDeep(contract);
      this.requests = cloneDeep(contract.requests);
      this.automateContractData.customAnchors = cloneDeep(contract.customAnchorsValues)
      await this.retrieveProposalsData();

      this.selectedProposal = cloneDeep(this.rawProposalsData.find(proposal => proposal.id_doc === contract.selectedProposalId))
    },
    openConfirmExpeditionModal() {
      this.confirmExpeditionModal = true;
    },
    async activateExpedition() {
      this.is_loading = true;

      if (
        !this.contract.clientSideSignedContract ||
        !this.contract.companySideSignedContract ||
        !this.contract.franchiseeSideSignedContract
      ) {
        showErrorSnackBar('É necessário marcar as 3 (três) confirmações!');
        this.is_loading = false;
        return;
      }

      if (!this.project.id_material) {
        const idMaterial = await MaterialsService.createMaterials({});

        await ProjectsService.updateProject(this.idProject, {
          id_material: idMaterial,
        });

        await ContractsService.updateContractById(this.idContract, this.contract);

        await UtilsProjects.updateProjectSteps(this.idProject, UtilsProjects.STEPS.MATERIALS, true);
        this.buttonMessage = 'Materiais Solicitados';
        this.enableNextStepButton = false;
        showSuccessSnackBar('Materiais Solicitados com sucesso!');
        await UtilsProjects.createSuccessLog(this.idProject, UtilsProjects.STEPS.MATERIALS, 'Materiais Solicitados', this.currentStep);
      }

      this.is_loading = false;
      this.closeContractModal();
    },
    handleContractChangeRequested() {
        this.addStautsProject(this.idProject, 506, 503);
        this.requestContractChanging = false;
        showSuccessSnackBar("Solicitação de alteração de contrato registrada com sucesso!");
    },
  },
  watch: {
    show_messages_dialog(newVal) {
      if (!newVal) {
        // Quando o diálogo é fechado, verifica novamente as mensagens não lidas
        this.checkUnreadMessages();
      }
    }
  },
  async created() {
    this.is_loading = true;

    if (this.idContract) {
      const [status, project] = await ProjectsService.getProjectById(this.idProject);
      this.project = project;

      await this.getContractFromDB();
      await this.checkUnreadMessages();

      if (this.project.id_material) {
        this.buttonMessage = 'Materiais Solicitados';
        this.enableNextStepButton = false;
      }
    }

    await this.retrieveFranchiseeInformation();
    await this.retrieveClientInformation();
    await this.getActivesContractsTemplates();

    this.is_loading = false;
  },
};

